exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Videos-___style__wrapper___187sW{max-width:800px;margin:auto}.src-components-Videos-___style__video-container___3zzQE{position:relative;display:block;height:0;padding:0;overflow:hidden;padding-bottom:56.25%}.src-components-Videos-___style__item___2kq3p{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Videos-___style__wrapper___187sW",
	"video-container": "src-components-Videos-___style__video-container___3zzQE",
	"item": "src-components-Videos-___style__item___2kq3p"
};